import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import history from '../../../../route/history'
import { alertActions, authActions, commonActions, certapplyActions, certissueActions } from '../../../../store/actions'
import Alert from '../../../../module/alert/Alert'

const CertIssueList = (props) => {
  //console.log('history = ', history.location.search);

  const goApply = (crtIssueSeq) => {
    history.push('/service/certapply/1?seq=' + crtIssueSeq + '&guBun=Y')
  }

  const goDetail = (crtSeq) => {
    //history.push({ pathname: '/service/certissue/detail/' + crtSeq, goUrl: history.location.search })
    history.push('/service/certissue/detail/' + crtSeq)
  }

  /**
   * 문서 삭제처리
   */
  const doDelete = (crtIssueSeq) => {
    props.confirm({
      title: '확인',
      message: '문서를 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.deleteDoc(crtIssueSeq)
        },
      },
    })
  }

  /**
   * 문서 PDF 생성
   */
  const doPdf = (crtSeq, crtIssueSeq) => {
    props.confirm({
      title: '확인',
      message: '증명서 PDF 생성하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          props.pdfFile(crtSeq, crtIssueSeq)
        },
      },
    })
  }

  /**
   * 문서 삭제 콜백
   */
  useEffect(() => {
    //console.log('props.isDelete', props.isDelete)
    if (props.isDelete === true) {
      window.location.replace('/service/certissue')
    }
    if (props.isPdf === true) {
      window.location.replace('/service/certissue')
    }
  }, [props.isDelete])

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (certIssueObj) => {
    // console.log('contract', contract)
    // console.log('props', props)

    let fileList = []
    if (certIssueObj?.fileList || certIssueObj?.attachList) {
      fileList = [...(certIssueObj?.fileList || []), ...(certIssueObj?.attachList || [])]
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/general/' + fileList[idx].encryptedId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.onload = function () {
          let _anchor = document.createElement('a')
          _anchor.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
          _anchor.download = val['originFileNm'] // Set the file name.
          _anchor.style.display = 'none'
          document.body.appendChild(_anchor)
          _anchor.click()
          document.body.removeChild(_anchor)
        }
        xhr.open('GET', url)
        xhr.send()
      }, 20)
    })
  }
  return (
    <>
      <div className="tbl-wrap mt20">
        <table className="tbl-list">
          <caption>신청방법, 증명서 및 발급번호, 발급처, 신청일시, 상태, 추가신청 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '9%' }} />
            <col style={{ width: '25%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '14%' }} />
            {/*   <col style={{width: '14%'}} />*/}
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">신청방법</th>
              <th scope="col">증명서 및 발급번호</th>
              <th scope="col">발급처</th>
              <th scope="col">신청일시</th>
              <th scope="col">상태</th>
              {/*  <th scope="col">결제상태</th>*/}
              <th scope="col">추가신청</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((certIssueObj, index) => (
                <tr key={index}>
                  <td onClick={() => props.onCertIssueDetail(certIssueObj)} className="cursor">
                    {certIssueObj.issueTypeNm}
                  </td>
                  <td onClick={() => props.onCertIssueDetail(certIssueObj)} className="cursor">
                    {certIssueObj.crtNm} <span className="txt1">{certIssueObj.docid}</span>
                  </td>
                  <td onClick={() => props.onCertIssueDetail(certIssueObj)} className="cursor">
                    {certIssueObj.issueNm}
                  </td>
                  <td onClick={() => props.onCertIssueDetail(certIssueObj)} className="cursor">
                    {certIssueObj.writedt === null ? '-' : moment(certIssueObj.writedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td onClick={() => props.onCertIssueDetail(certIssueObj)} className="cursor">
                    {certIssueObj.sts === '04' && <span className="text-red">{certIssueObj?.stsNm}</span>}
                    {certIssueObj.sts === '03' && <span className="text-black">{certIssueObj?.stsNm}</span>}
                    {certIssueObj.sts === '02' && <span className="text-blue">{certIssueObj?.stsNm}</span>}
                  </td>
                  {/*
                  <td onClick={() => goDetail(certIssueObj.crtSeq)} className="cursor">
			          {certIssueObj?.sts === '02' && certIssueObj?.rtrcnDt === null ? (
			              <span className="text-blue">결제완료</span>
			          ) : (
                      	<span className="text-red">결제취소</span>
			            
			          )}
                  </td> */}
                  <td>
                    {certIssueObj.sts !== '03' && (
                      <a href="#" className="btn-secondary md" onClick={() => goApply(certIssueObj.crtIssueSeq)}>
                        재신청
                      </a>
                    )}
                    {certIssueObj.sts === '04' && (
                      <a href="#" className="btn-secondary md" onClick={() => doDelete(certIssueObj.crtIssueSeq)}>
                        취소
                      </a>
                    )}
                    {(certIssueObj.sts === '03' && certIssueObj.fileGroupId === null) && (
                      <a href="#" className="btn-secondary md" onClick={() => doPdf(certIssueObj.crtSeq, certIssueObj.crtIssueSeq)}>
                        PDF 생성
                      </a>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={6}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certIssueInfo: state.certissue?.certIssueInfo,
    isDelete: state.certapply.isDelete,
    isPdf: state.certapply.isPdf,
  }
}

const actionCreators = {
  getCertIssueInfo: certissueActions.getCertIssueInfo,
  changeSearchInfo: certissueActions.changeSearchInfo,
  success: certissueActions.success,
  readCertIssueList: certissueActions.readCertIssueList,
  getCommonCode: commonActions.getCommonCode,
  deleteDoc: certapplyActions.deleteTempDoc,
  pdfFile: certapplyActions.pdfTempFile,
  confirm: alertActions.confirm,
}

export default connect(mapStateToProps, actionCreators)(CertIssueList)
